import { useParams } from 'react-router-dom';
import TableComponent from '../components/TableComponent';

const SharedWeeklyPicks = () => {
  const { userId } = useParams();

  return (
    <TableComponent singleUserUrlLink={userId} />
  );
};

export default SharedWeeklyPicks;
